<div class="card-body">
    <div id="apex-basic-bar-chart"></div>
</div>